/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'heading-links.scss' instead.
import { css } from 'lit';
export default css `:host a,:host button{font-weight:var(--cipublic-font-weight-medium)}`;
//# sourceMappingURL=heading-links.scss.js.map